import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  action?: { label: string; onClick: () => void };
  className?: string;
}

export function EmptyState({ icon: Icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cn("card-surface text-center py-20 px-6", className)}>
      <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-2xl bg-gray-50 text-gray-400">
        <Icon size={28} />
      </div>
      <h3 className="text-base font-black uppercase tracking-tight text-[#003366]">{title}</h3>
      {description && (
        <p className="mx-auto mt-2 max-w-sm text-sm font-medium text-gray-500">{description}</p>
      )}
      {action && (
        <button
          type="button"
          onClick={action.onClick}
          className="mt-6 rounded-xl bg-indigo-600 px-5 py-2.5 text-[10px] font-black uppercase tracking-[0.2em] text-white transition-colors hover:bg-indigo-700"
        >
          {action.label}
        </button>
      )}
    </div>
  );
}
